import { Component } from 'opus-angular-seed-core';

/**
 * This component is currently only used by quiz feedback forms because 360 evaluation does not permit radio questions
 */
@Component({
    bindings: {
        question: '=',
        form: '=',
        counter: '=',
        answeredQuestions: '='
    },
    template: `
        <div class="alert alert-danger" ng-if="vm.form.answers[vm.index].errors.answerId">{{ vm.form.answers[vm.index].errors.answerId }}</div>
        <h3 ng-bind-html="vm.questionName | isRequired: vm.question.formQuestions[0].isRequired"></h3>
        <ul class="checkboxes inxcols">
            <li ng-repeat="answer in vm.question.questionAnswers">
                <label><input type="radio" ng-model="vm.answer.answerId"
                        ng-change="vm.onChange('{{vm.answer.answerId}}')"
                        ng-value="answer.id" name="question-{{ vm.question.id }}"
                ><span>{{ answer.text }}</span></label>
            </li>
        </ul>
    `
})
export default class {
    constructor (lodash, FormSubmissionService) {
        this.submittedAnswerId = lodash.get(this.question, 'submittedAnswer.id', null);
        this.submittedAnswerAnswerId = lodash.get(this.question, 'submittedAnswer.answerId', null);
        this.answer = {
            id: this.submittedAnswerId,
            questionId: this.question.id,
            language: this.form.language,
            answerId: this.submittedAnswerAnswerId
        };
        this.index = FormSubmissionService.registerAnswer(this.form.answers, this.answer);
    }

    $onInit () {
        this.questionName = `${this.counter}. ${this.question.activeI18n.name}`;
        if (this.submittedAnswerId && this.submittedAnswerAnswerId) {
            this.answeredQuestions = this.answeredQuestions + 1;
        }
    }

    onChange (oldAnswerId) {
        if (oldAnswerId) {
            this.answeredQuestions = this.answeredQuestions - 1;
        }
        this.form.answers[this.index] = this.answer;
        this.answeredQuestions = this.answeredQuestions + 1;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/evaluation/public/evaluation/question/radio/index.js